import { DateTime } from 'luxon'
import { TIME_DURATION, TIME_FORMAT } from '@/context/constants'
import { IConversation } from '@/context/types'

import { PROPERTY_STATUS } from '@/components/ContentTypes/constants'
import { Listing, Property } from './types'

export const formatDateRelative = (datetime: string) => {
  const diffNow = DateTime.fromISO(datetime).diffNow().as('seconds')

  // If within 15 seconds, consider as just now
  if (diffNow > -TIME_DURATION.FIFTEEN_SECONDS) {
    return 'Just now'
  }
  // If within 16sec to 5 minutes, use relative format
  else if (
    diffNow < -(TIME_DURATION.FIFTEEN_SECONDS + 1) &&
    diffNow > -TIME_DURATION.FIVE_MINUTES
  ) {
    return DateTime.fromISO(datetime).toRelative()
  }

  return DateTime.fromISO(datetime).toFormat(TIME_FORMAT)
}

export const formatConversationDateRelative = (datetime: string) => {
  const diffNow = DateTime.fromISO(datetime).diffNow().as('seconds')

  // If within 15 seconds, consider as just now
  if (diffNow > -TIME_DURATION.FIFTEEN_SECONDS) {
    return 'Just now'
  }

  return DateTime.fromISO(datetime).toRelative()
}

export const sortByDateDesc = (conversationsToStort: IConversation[]) => {
  conversationsToStort.sort(
    (a, b) =>
      new Date(b.metadata?.lastMessage?.received || b.lastUpdatedAt).getTime() -
      new Date(a.metadata?.lastMessage?.received || a.lastUpdatedAt).getTime(),
  )
}

export const isConversationExpired = (
  conversation: IConversation | undefined,
) => {
  if (!conversation) {
    return false
  }

  const diffNow = DateTime.fromISO(conversation?.lastUpdatedAt)
    .diffNow()
    .as('seconds')

  // If last update within dialogflow timeout of 30 minutes, not expired
  if (
    diffNow > -(TIME_DURATION.THIRTY_MINUTES - TIME_DURATION.THIRTY_SECONDS)
  ) {
    return false
  }
  return true
}

const getListingFromProperty = (
  property: Property,
  status: string[],
): Listing =>
  property.listings.find((listing: Listing) =>
    status.includes(listing.status),
  ) as Listing

export const getListingIdsFromProperties = (properties: Property[]) => {
  return properties
    .map((property: Property): string => {
      const listing = getListingFromProperty(property, [
        PROPERTY_STATUS.LEASED,
        PROPERTY_STATUS.NEW,
        PROPERTY_STATUS.ACTIVE,
      ])
      return listing && listing.listingID
    })
    .filter(Boolean)
}

export const capitalize = (str: string) => {
  if (!str) {
    return null
  }

  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1)
}

export default {
  formatDateRelative,
  formatConversationDateRelative,
  sortByDateDesc,
  isConversationExpired,
  capitalize,
}
